import axios from './axios';
import { CHILDREN_PER_PAGE } from 'constants/Values';

/**
 * Get list of programs
 */
export const listPrograms = () => axios.get(`/eca/programs`);
export const createProgram = program => axios.post(`/eca/programs`, program);
export const updateProgram = program => {
  const { id, ...rest } = program;
  return axios.post(`/eca/programs/${id}`, rest);
};
export const deleteProgram = programId => axios.delete(`/eca/programs/${programId}`);
export const programDetails = programId => axios.get(`/eca/programs/${programId}`);

export const createActivity = activity => axios.post(`/eca/activities`, activity);
export const updateActivity = activity => {
  const { id, ...rest } = activity;
  return axios.post(`/eca/activities/${id}`, rest);
};
export const deleteActivity = activityId => axios.delete(`/eca/activities/${activityId}`);
export const activityDetails = activityId => axios.get(`/eca/activities/${activityId}`);
export const activityEventsParticipants = activityId =>
  axios.get(`/eca/activities/${activityId}/events/participants`);

export const createEvent = event => axios.post(`/eca/events`, event);
export const updateEvent = event => {
  const { id, ...rest } = event;
  return axios.post(`/eca/events/${id}`, rest);
};
export const deleteEvent = eventId => axios.delete(`/eca/events/${eventId}`);
export const eventDetails = eventId => axios.get(`/eca/events/${eventId}`);
export const activeEventDetailsForEvent = eventId => axios.get(`/eca/events/${eventId}/active`);

export const addActivityParticipants = payload => {
  const { id, pupilIds } = payload;
  return axios.put(`/eca/activities/${id}/participants`, { pupilIds });
};
export const deleteActivityParticipants = payload => {
  const { id, pupilIds } = payload;
  if (pupilIds) {
    return axios.delete(`/eca/activities/${id}/participants`, { data: { pupilIds } });
  }
  return axios.delete(`/eca/activities/${id}/participants`);
};
export const addActivityLeads = payload => {
  const { id, staffIds } = payload;
  return axios.put(`/eca/activities/${id}/leads`, { staffIds });
};
export const deleteActivityLeads = payload => {
  const { id, staffIds } = payload;
  return axios.delete(`/eca/activities/${id}/leads`, { data: { staffIds } });
};
export const addEventParticipants = payload => {
  const { id, pupilIds } = payload;
  return axios.put(`/eca/events/${id}/participants`, { pupilIds });
};
export const updateParticipantNext = payload => {
  const { eventId, participantId, preference } = payload;
  return axios.put(`/eca/events/${eventId}/participants/${participantId}/next/${preference}`);
};
export const deleteEventParticipants = payload => {
  const { id, pupilIds } = payload;
  return axios.delete(`/eca/events/${id}/participants`, { data: { pupilIds } });
};
export const addEventCoordinators = payload => {
  const { id, staffIds } = payload;
  return axios.put(`/eca/events/${id}/coordinators`, { staffIds });
};
export const deleteEventCoordinators = payload => {
  const { id, staffIds } = payload;
  return axios.delete(`/eca/events/${id}/coordinators`, { data: { staffIds } });
};
export const todayEvents = () => axios.get(`/eca/events/today`);
export const searchEventsByParticipants = participantIds =>
  axios.post('/eca/events/search/participants', {
    pupilIds: participantIds,
    pagination: {
      pageNumber: 1,
      size: 1000,
    },
  });

// ECA History API
export const getEventsHistory = query => axios.post('/eca/events/history/search', query);

export const getEventHistoryTabs = () => axios.get('/eca/events/history/tabs');

export const getEventHistoryTabData = (eventId, tabPath, query) =>
  axios.post(`/eca/events/history/${eventId}${tabPath}`, query);
